import styled from '@emotion/styled';
import { mq } from '../../../../styles/mixins';
import { css } from '@emotion/react';

export const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 35.5625rem;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 3.5rem 2rem 2rem 2rem;
  background: #fff;
  border-radius: 0.5rem;

  ${mq.xLarge(css`
    padding: 3rem;
  `)}
`;

export const Title = styled.div`
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0em;
  text-align: left;
  color: #000000;
  border: solid 0.0625rem transparent;
  position: relative;

  &:before {
    content: ' ';
    position: absolute;
    height: 0.125rem;
    right: 0;
    bottom: 0;
    left: 0;
    margin: -5px;
    border-radius: inherit;
    background: linear-gradient(89.99deg, #0e4ed7 -15.08%, #f94743 93.47%);
  }
`;

export const Description = styled.p`
  font-family: var(--font-second);
  font-size: 16px;
  font-weight: 300;
  line-height: 32px;
  letter-spacing: 0.20000000298023224px;
  text-align: left;
  color: #667070;
`;
